export const getclassesIrc = (state) => state.classesIrc.lista
export const getIsCarregandoListaclassesIrc = (state) => state.classesIrc.isCarregandoLista
export const getIsSavingClassesIrc = (state) => state.classesIrc.isSaving
export const getIsUpdatingClassesIrc = (state) => state.classesIrc.isUpdate
